<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasQuest.value" :to="{ name: 'rh-aval-questionarios' }">Questionários</v-btn>
            <v-btn v-if="hasPeriodPerm.value" :to="{ name: 'rh-aval-periodos' }">Períodos</v-btn>
            <v-btn v-if="hasAvaliarPerm.value" :to="{ name: 'rh-aval-avaliacoes' }">Avaliações</v-btn>
            <v-btn v-if="hasColabPerm.value" :to="{ name: 'rh-aval-colaboradores' }">Colaboradores</v-btn>
            <v-btn v-if="hasMentoriaPerm.value" :to="{ name: 'rh-aval-mentorias' }">Mentorias</v-btn>
            <v-btn v-if="hasTempoCasaPerm.value" :to="{ name: 'rh-aval-tempo-casa' }">Satisf. Colaborador</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
    import { ref, computed } from 'vue';
    import  { useRouter } from 'vue-router';
    const hasQuest = ref(false)
    const hasPeriodPerm = ref(false)
    const hasAvaliarPerm = ref(false)
    const hasColabPerm = ref(false)
    const hasMentoriaPerm = ref(false)
    const hasTempoCasaPerm = ref(false)
    const router = useRouter();
    hasQuest.value = computed(() => router.resolve({name: 'rh-aval-questionarios'}).meta.has_perm())
    hasPeriodPerm.value = computed(() => router.resolve({name: 'rh-aval-periodos'}).meta.has_perm())
    hasAvaliarPerm.value = computed(() => router.resolve({name: 'rh-aval-avaliacoes'}).meta.has_perm())
    hasColabPerm.value = computed(() => router.resolve({name: 'rh-aval-colaboradores'}).meta.has_perm())
    hasMentoriaPerm.value = computed(() => router.resolve({name: 'rh-aval-mentorias'}).meta.has_perm())
    hasTempoCasaPerm.value = computed(() => router.resolve({name: 'rh-aval-tempo-casa'}).meta.has_perm())
</script>